import { PlanType } from '@showbie-socrative/socrative-utils';

import {
  essentialsPermission,
  freePermission,
  legacyFreePermission,
  proPermission,
  starterPermission,
} from './simplePermissions';

/**
 * Function used for determining permissions. Primarily used to make it simpler to check permissions.
 * @param args
 * @param args.plan - user plan (Free, LegacyFree, Starter, Pro, etc)
 * @param args.userVersion - version 1 users had unlimited quizzes, but features
 * were paywalled. version 2 and up, have less paywalled feature, but limited quizzes.
 */
export function determinePermissions({
  plan,
  userVersion = 3,
}: {
  plan: PlanType;
  userVersion?: number;
}) {
  if (
    plan === PlanType.Pro ||
    plan === PlanType.Complete ||
    plan === PlanType.Organization
  ) {
    return proPermission;
  } else if (plan === PlanType.Starter) {
    return starterPermission;
  } else if (plan === PlanType.Essentials) {
    return essentialsPermission;
  } else if (userVersion >= 2) {
    // TODO remove once every user is version 3, this else can just become else to return the simple free permission
    return freePermission;
  } else {
    return legacyFreePermission;
  }
}
